import { FC } from 'react'
import { ISubsidyBase } from '@/types'
import { sanitizeUrl } from '@/utils'
import { SubsidyCardContent } from '@components-v2/molecules/SubsidyCardContent'
import { ListingSearchResult } from '@components-v2/molecules/ListingSearchResult'

type Props = {
  subsidy: ISubsidyBase
}

export const SubsidyCard: FC<Props> = ({ subsidy }) => {
  const linkToJobDetails = sanitizeUrl(`/subsidies/${subsidy?.id}`)

  return (
    <ListingSearchResult href={linkToJobDetails}>
      <SubsidyCardContent subsidy={subsidy} />
    </ListingSearchResult>
  )
}
